/**
 * MARAVEL — Custom Mega Menu + Mobile Nav
 * Vanilla JS only. Zero dependencies.
 */

(function () {
  'use strict';

  /* ─── MegaMenu (desktop) ───────────────────────────────────────────────── */
  class MaravelMegaMenu {
    constructor(nav) {
      this.nav = nav;
      this.items = Array.from(nav.querySelectorAll('.mv-nav-item'));
      this.activeItem = null;
      this._closeTimer = null;
      this.init();
    }

    init() {
      this.items.forEach(item => {
        const trigger = item.querySelector('.mv-nav-link');
        const dropdown = item.querySelector('.mv-dropdown');

        if (!dropdown) return; // plain link, no sub-menu

        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-haspopup', 'true');

        item.addEventListener('mouseenter', () => {
          clearTimeout(this._closeTimer);
          this.open(item);
        });

        item.addEventListener('mouseleave', () => {
          this._closeTimer = setTimeout(() => this.close(item), 80);
        });

        dropdown.addEventListener('mouseenter', () => {
          clearTimeout(this._closeTimer);
        });

        dropdown.addEventListener('mouseleave', () => {
          this._closeTimer = setTimeout(() => this.close(item), 80);
        });

        // keyboard: Enter/Space toggles
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            item.classList.contains('is-open') ? this.close(item) : this.open(item);
          }
        });

        // focus within dropdown keeps it open
        dropdown.addEventListener('focusin', () => {
          clearTimeout(this._closeTimer);
          this.open(item);
        });

        dropdown.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) {
            this._closeTimer = setTimeout(() => this.close(item), 80);
          }
        });
      });

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.mv-nav-item')) this.closeAll();
      });

      // Close on Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeAll();
      });
    }

    open(item) {
      if (this.activeItem && this.activeItem !== item) {
        this.close(this.activeItem);
      }
      item.classList.add('is-open');
      const trigger = item.querySelector('.mv-nav-link');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      this.activeItem = item;
    }

    close(item) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('.mv-nav-link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (this.activeItem === item) this.activeItem = null;
    }

    closeAll() {
      this.items.forEach(item => this.close(item));
    }
  }

  /* ─── Mobile Nav ───────────────────────────────────────────────────────── */
  class MaravelMobileNav {
    constructor() {
      this.nav     = document.getElementById('mv-mobile-nav');
      this.overlay = document.getElementById('mv-mobile-overlay');
      this.openBtn = document.querySelector('[data-mv-hamburger]');
      this.closeBtn = document.getElementById('mv-mobile-close');
      this.subTriggers = [];
      if (!this.nav) return;
      this.init();
    }

    init() {
      if (this.openBtn) {
        this.openBtn.addEventListener('click', () => this.open());
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      // Sub-nav toggles
      this.nav.querySelectorAll('[data-mv-sub-trigger]').forEach(btn => {
        btn.addEventListener('click', () => {
          const subId = btn.getAttribute('data-mv-sub-trigger');
          const sub = document.getElementById(subId);
          if (!sub) return;
          const isOpen = sub.classList.contains('is-open');
          // Close all siblings first
          this.nav.querySelectorAll('.mv-mobile-subnav').forEach(s => s.classList.remove('is-open'));
          this.nav.querySelectorAll('[data-mv-sub-trigger]').forEach(b => b.setAttribute('aria-expanded', 'false'));
          if (!isOpen) {
            sub.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      // Close on Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    open() {
      this.nav.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.nav.setAttribute('aria-hidden', 'false');
    }

    close() {
      this.nav.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      this.nav.setAttribute('aria-hidden', 'true');
    }
  }

  /* ─── Boot ──────────────────────────────────────────────────────────────── */
  function init() {
    const desktopNav = document.querySelector('.mv-desktop-nav');
    if (desktopNav) {
      new MaravelMegaMenu(desktopNav);
    }

    new MaravelMobileNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
